import { createBrowserRouter, Navigate } from "react-router-dom";

import HomePage from "../Pages/HomePage/Home-Page";
import SignUp from "../Pages/SignUpPage/Sign-Up";
import PageNotFound from "../Pages/ErrorPage/PageNotFound/Page-Not-Found";
import PatientPage from "../Pages/PatientsPage/Patient-Page";
import DietMaster from "../Pages/DietsPage/Diet-Master";
import Layout from "../Pages/Components/Layout";
import PatientDietPage from "../Pages/PatientDietPage/Patient-Diet-Page";
import PaymentsPage from "../Pages/PaymentsPage/Payments-Page";
import PatientAddFormOpen from "../Pages/PatientsPage/PatientAddFormOpen";
import PatientAddShort from "../Pages/PatientsPage/PatientAddShort";
import PatientView from "../Pages/PatientsPage/Patient-View";
import PatientEdit from "../Pages/PatientsPage/Patient-Form";
import PatientPaymentsView from "../Pages/PatientsPage/Payment-View";
import PatientDietPlanList from "../Pages/PatientsPage/Patient-Diet-Plan";
import PatientDietPlanViewPage from "../Pages/PatientDietPage/PatientDietPlanViewPage";
import PatientDietPlanEditPage from "../Pages/PatientDietPage/PatientDietPlanEditPage";

const router = createBrowserRouter([
  
  {
    path: "auth/SignUp",
    exact: true,
    element: <SignUp />,
  },
  {
    path: "add-patient",
    exact: true,
    element: <PatientAddFormOpen />,
  },
  {
    path: "patients/add",
    element: <Layout AppnavHeading="Add Patient" HeaderHeading="Add Patient" />,
    children: [
      {
        index: true,
        element: <PatientAddShort />,
      },
    ],
  },
  {
    path: "patients/:id/view",
    element: <Layout AppnavHeading="Patients" HeaderHeading="Patient Details" />,
    children: [
      {
        index: true,
        element: <PatientView />,
      },
    ],
  },
  {
    path: "patients/:id/edit",
    element: <Layout AppnavHeading="Patients" HeaderHeading="Edit Patient" />,
    children: [
      {
        index: true,
        element: <PatientEdit />,
      },
    ],
  },
  {
    path: "patients/:id/payments",
    element: <Layout AppnavHeading="Patients" HeaderHeading="Payments" />,
    children: [
      {
        index: true,
        element: <PatientPaymentsView />,
      },
    ],
  },
  {
    path: "patients/:id/diet-plans",
    element: <Layout AppnavHeading="Patients" HeaderHeading="Diet Plans" />,
    children: [
      {
        index: true,
        element: <PatientDietPlanList />,
      },
    ],
  },
  {
    path: "/",
    element: <Layout AppnavHeading="Patients" HeaderHeading="Patients" />,  // Wrap Patients in Layout
    children: [
      {
        index: true,
        element: <Navigate to="/patients" replace />,
      },
      {
        path: "patients",
        element: <PatientPage />,
      },
    ],
  },
  {
    path: "diet-master",
    element: <Layout AppnavHeading="Diet Master" HeaderHeading="Diet Master" />,  // Wrap Diet Master in Layout
    children: [
      {
        index: true,
        element: <DietMaster />,
      },
    ],
  },
  {
    path: "patient-diet",
    element: <Layout AppnavHeading="Patient Diet" HeaderHeading="Patient Diet" />,  // Wrap Diet Master in Layout
    children: [
      {
        index: true,
        element: <PatientDietPage />,
      },
    ],
  },
  {
    path: "patient-diet/:id/view",
    element: <Layout AppnavHeading="Patient Diet" HeaderHeading="" />,
    children: [
      {
        index: true,
        element: <PatientDietPlanViewPage />,
      },
    ],
  },
  {
    path: "patient-diet/:id/edit",
    element: <Layout AppnavHeading="Patient Diet" HeaderHeading="Edit Diet Plan" />,
    children: [
      {
        index: true,
        element: <PatientDietPlanEditPage />,
      },
    ],
  },
  {
    path: "payments",
    element: <Layout AppnavHeading="Payments" HeaderHeading="Payments" />,  // Wrap Diet Master in Layout
    children: [
      {
        index: true,
        element: <PaymentsPage />,
      },
    ],
  },
  {
    path: "*",
    exact: true,
    element: <PageNotFound />,
  },
]);

export default router;
